//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import {
  ITwitterUser,
  ITwitterUserSearchRequest,
  ITwitterUserSearchResponse,
} from '@apis/twitter-search/twitterSearchApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const TWITTER_BASE_URL = '/api/v1/twitter';

const twitterGatewaySearchFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'twitter_gateway',
    `${TWITTER_BASE_URL}${endpoint}`,
    init,
  );
};

/**
 * Gets list of Twitter users matching query
 *
 * GET /api/v1/twitter/users/search
 */
export const searchUser = async (
  req: ITwitterUserSearchRequest,
): Promise<ITwitterUser[]> => {
  const params = makeParams({
    query: req.query,
    count: req.count,
  });
  const res = await twitterGatewaySearchFetch(`/users/search?${params}`);

  const userSearchResponse = await res.json<ITwitterUserSearchResponse>();

  return userSearchResponse.data;
};
